/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

define([
  "marionette",
  "modules/quickCreate/quickContentModal/currentContent/template/currentContentTemplate.html",
], function (Marionette, CurrentContentTemplate) {
  var CurrentContentView = {};

  CurrentContentView.currentContentView = Marionette.ItemView.extend({
    template: CurrentContentTemplate,
    modelEvents: {
      sync: "render",
    },
    triggers: {
      "click #deleteAssociatedContent": "remove:content",
    },
  });

  return CurrentContentView;
});
